module.exports = __webpack_public_path__ + "img/3.1b2fc874.jpg";